import ProductCards from "./productCards";
import Footer from "./footer";
import Header from "./header";
import AmlaPickle from '../images/pickles/AmlaPickle.png';
import ChickenPickle from '../images/pickles/ChickenPickle.png';
import DuckPickle from '../images/pickles/DuckPickle.png';
import LemonPickle from '../images/pickles/LemonPickle.png';
import banner3 from '../images/banner3.png'

function Rice({addToCart}){
    const products = [
  {
    id: 1,
    name: "Amla Pickle",
    image: AmlaPickle,
    rating: "4.7 | 279 Reviews",
    tags: ["Sweet & Tangy", "Oil Free",'Veg'],
    prices: ["Rs 299 (MRP 400)", "Rs 499 (MRP 600)"]
  },
  {
    id: 2,
    name: "Chicken Pickle",
    image: ChickenPickle,
    rating: "4.8 | 184 Reviews",
    tags: ["Spicy", "Non-veg", "Mustard Oil"],
    prices: ["325g - Rs 299 (MRP 400)", "500g - Rs 399 (MRP 500)"]
  },
  {
    id: 3,
    name: "Duck Pickle",
    image: DuckPickle,
    rating: "4.7 | 180 Reviews",
    tags: ["Spicy", "Mustard Oil", 'Non-veg'],
    prices: ["325g - Rs 299 (MRP 400)", "500g - Rs 399 (MRP 500)"]
  },
  {
    id: 4,
    name: "Lemon Pickle",
    image: LemonPickle,
    rating: "4.8 | 101 Reviews",
    tags: ["Sour & spicy", "Veg", "Sunflower Oil"],
    prices: ["325g - Rs 299 (MRP 400)", "500g - Rs 399 (MRP 500)"]
  }
];
    return(
        <div>
            <Header title = {"Rice"} banner = {banner3}/>
            <div>
                <ProductCards addToCart={addToCart} products={products}/>
            </div>
            <Footer/>
        </div>
    )
}

export default Rice;

